var path = 'event/event-row-error.tpl.html';
var html = " <div class=tb-cell flex=30>{{event.createdTime | date : 'yyyy-MM-dd HH:mm:ss'}}</div> <div class=tb-cell flex=20>{{event.body.server}}</div> <div class=tb-cell flex=20>{{event.body.method}}</div> <div class=tb-cell flex=20> <md-button ng-if=event.body.error class=\"md-icon-button md-primary\" ng-click=\"showContent($event, event.body.error, 'event.error')\" aria-label=\"{{ 'action.view' | translate }}\"> <md-tooltip md-direction=top> {{ 'action.view' | translate }} </md-tooltip> <md-icon aria-label=\"{{ 'action.view' | translate }}\" class=material-icons> more_horiz </md-icon> </md-button> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/event/event-row-error.tpl.html
// module id = 1483
// module chunks = 1